module.exports = __webpack_public_path__ + "img/icon2.3dafd9c2.png";